import "../sections/sections.css";
import "./about.css";

import React from "react";

import { ABOUT, GALLERY, TESTIMONIAL } from "../../data/about";
import Lightbox from "../general/Lightbox";
import PageMeta from "../general/PageMeta";
import SectionTitle from "../general/SectionTitle";

const pad = (n) => String(n).padStart(3, "0");
const PHOTOS = Array.from({ length: GALLERY.PHOTO_COUNT }, (_, i) => ({
  src: `/images/gallery/${pad(i + 1)}.webp`,
  thumb: `/images/gallery/thumbs/${pad(i + 1)}.webp`,
  alt: `Estia event photo ${i + 1}`,
}));

//Wix showed all 357 photos at once in a very long page - they now load in batches, and open full-size in a viewer
const Gallery = () => {
  const [shown, setShown] = React.useState(GALLERY.PAGE_SIZE);
  const [openIndex, setOpenIndex] = React.useState(null);
  const listRef = React.useRef(null);

  const showMore = () => {
    const firstNew = shown;
    setShown(Math.min(shown + GALLERY.PAGE_SIZE, PHOTOS.length));
    //Move keyboard focus to the first new photo
    window.setTimeout(() => {
      const button = listRef.current && listRef.current.querySelectorAll("button")[firstNew];
      if (button) {
        button.focus({ preventScroll: true });
      }
    }, 50);
  };

  return (
    <section
      className={"about-gallery"}
      aria-labelledby={"gallery-title"}
    >
      <div className={"about-gallery-banner"}>
        <img
          src={GALLERY.BANNER.src}
          alt={""}
          width={GALLERY.BANNER.width}
          height={GALLERY.BANNER.height}
          loading={"lazy"}
        />
        <div className={"about-gallery-banner-text"}>
          <h2 id={"gallery-title"}>{GALLERY.TITLE}</h2>
          <img
            src={"/images/divider.png"}
            alt={""}
            width={106}
            height={31}
            className={"section-divider"}
          />
          <p>{GALLERY.TEXT}</p>
        </div>
      </div>

      <ul
        ref={listRef}
        className={"about-gallery-grid"}
      >
        {PHOTOS.slice(0, shown).map((photo, i) => (
          <li key={photo.src}>
            <button
              type={"button"}
              className={"about-gallery-item"}
              aria-label={`Open photo ${i + 1} of ${PHOTOS.length}`}
              onClick={() => setOpenIndex(i)}
            >
              <img
                src={photo.thumb}
                alt={""}
                width={375}
                height={500}
                loading={"lazy"}
              />
            </button>
          </li>
        ))}
      </ul>
      {shown < PHOTOS.length ? (
        <div className={"btn-row about-gallery-more"}>
          <button
            type={"button"}
            className={"btn"}
            onClick={showMore}
          >
            Show more photos
          </button>
          <p className={"about-gallery-count"}>
            Showing {shown} of {PHOTOS.length}
          </p>
        </div>
      ) : null}

      <Lightbox
        title={GALLERY.TITLE}
        photos={PHOTOS}
        index={openIndex}
        onClose={() => setOpenIndex(null)}
      />
    </section>
  );
};

const About = () => (
  <React.Fragment>
    <PageMeta
      title={"About"}
      description={ABOUT.PARAGRAPHS[0]}
    />

    <section className={"about-intro"}>
      <div className={"container"}>
        <div className={"about-box about-intro-box"}>
          <div className={"about-intro-text"}>
            <h1 className={"about-title"}>{ABOUT.TITLE}</h1>
            {ABOUT.PARAGRAPHS.map((p) => <p key={p}>{p}</p>)}
          </div>
          <img
            src={ABOUT.IMAGE.src}
            alt={ABOUT.IMAGE.alt}
            width={ABOUT.IMAGE.width}
            height={ABOUT.IMAGE.height}
            className={"about-intro-photo"}
          />
        </div>

        <figure className={"about-box about-testimonial"}>
          <SectionTitle>{TESTIMONIAL.TITLE}</SectionTitle>
          <div className={"about-testimonial-body"}>
            <img
              src={TESTIMONIAL.IMAGE.src}
              alt={TESTIMONIAL.IMAGE.alt}
              width={TESTIMONIAL.IMAGE.width}
              height={TESTIMONIAL.IMAGE.height}
              className={"about-testimonial-photo"}
              loading={"lazy"}
            />
            <blockquote>
              <p>
                <strong>{TESTIMONIAL.LEAD}</strong> {TESTIMONIAL.PARAGRAPHS[0]}
              </p>
              {TESTIMONIAL.PARAGRAPHS.slice(1).map((p) => <p key={p}>{p}</p>)}
            </blockquote>
          </div>
          <figcaption className={"about-testimonial-footer"}>
            <span>
              {TESTIMONIAL.RATING[0]}
              <strong>{TESTIMONIAL.RATING[1]}</strong>
              <span
                className={"about-stars"}
                aria-hidden={"true"}
              >
                ★★★★★
              </span>
            </span>
            <cite>{TESTIMONIAL.NAME}</cite>
          </figcaption>
        </figure>
      </div>
    </section>

    <Gallery />
  </React.Fragment>
);

export default About;
